export default __webpack_public_path__ + "static/images/fe35f2a5c1aa6aad762c88f2ee7e31a7.png";